import React from 'react';
import { Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AgentRequestForm from '../components/AgentRequest';
import ResponsiveAppBar from '../layout/ResponsiveAppBar';
import Footer from '../layout/Footer';

const CreateRequestPage = () => {
  const navigate = useNavigate();
  return (
    <>
      <ResponsiveAppBar />
      <Container maxWidth="xl">
        <AgentRequestForm
          onSubmitted={() => {
            navigate('/');
          }}
        />
      </Container>
      <Footer />
    </>
  );
};

export default CreateRequestPage;
